<template>
  <v-container class="pa-0" style="position: absolute;top: 0;bottom: 0;right: 0;left: 0; background-color: transparent">
    <div style="display: flex;flex-direction: column;justify-content: flex-start; height: 100%; background-color: transparent">
      <div style="background-color: transparent">
        <div v-if="filterOptions" style="overflow-y: auto; overflow-x: hidden; height: calc(100vh - 80vh); width: 100%">
          <v-row class="justify-end mr-1">
            <v-btn class="pushButton" dark text @click="filterOptions=!filterOptions">
              <strong> {{ $t('Close') }} </strong>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
          <div class="row container">
            <div class="col" style="text-align: center">
              <strong style="font-size: small">{{ $t('Client') }}</strong>
              <v-select
                v-model="selectedClient"
                :items="options"
                class="smallSelectable"
                color="black"
                @change="filter"
              />
            </div>


            <div class="col" style="text-align: center;">
              <strong style="font-size: small">{{ $t('MainView.Min Date') }}</strong>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="0"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    color="black"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="date"
                  @input="filter"

                />
              </v-menu>
              <v-spacer />
            </div>
            <div class="col" style="text-align: center">
              <strong style="font-size: smaller">{{ $t('Amount') }}</strong>
              <v-text-field
                v-model="amount"
                color="black"
                hide-details="auto"
                label="Min"
                @change="filter"
              />
            </div>
          </div>

          <div style="text-align: right">
            <v-row justify="space-around">
              <v-btn text class="pushButton" style="text-align: center; " @click="activateOptions">
                <strong>{{ $t('MainView.Advanced Options') }}</strong>
              </v-btn>
              <v-btn text class="pushButton" @click="reset">
                <strong>{{ $t('MainView.Reset') }}</strong>
              </v-btn>
            </v-row>
          </div>


          <div v-if="advancedOpt" class="container">
            <v-card-text>
              <v-row justify="center">
                <strong>{{ $t('MainView.Min-Max Amount') }}</strong>
              </v-row>
              <v-layout row>
                <v-flex
                  shrink
                  style="width: 60px; "
                >
                  <v-text-field
                    v-model="range[0]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                    style="font-size: small"
                    @change="advancedOptions"
                  />
                </v-flex>
                <v-flex class="px-3">
                  <v-range-slider
                    v-model="range"
                    :max="max"
                    :min="min"
                    color="black"
                    @change="advancedOptions"
                  />
                </v-flex>
                <v-flex
                  shrink
                  style="width: 60px"
                >
                  <v-text-field
                    v-model="range[1]"
                    class="mt-0"
                    hide-details
                    single-line
                    type="number"
                    style="font-size: small"
                    @change="advancedOptions"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
          </div>

          <div v-if="advancedOpt" class="container">
            <v-row justify="center" style="font-size: small">
              <strong>{{ $t('MainView.Introduce Min and Max Date') }}</strong>
            </v-row>
            <v-row>
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="advancedDateMin"
                    label="Min date"
                    prepend-icon="mdi-calendar"
                    readonly
                    color="black"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="advancedDateMin"
                  @input="advancedOptions"
                />
              </v-menu>
              <v-spacer />
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="advancedDateMax"
                    label="Max Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    color="black"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="advancedDateMax"
                  @input="advancedOptions"
                />
              </v-menu>
            </v-row>
          </div>
        </div>
        <div v-if="!filterOptions">
          <v-row class="justify-end mr-1">
            <v-btn class="pushButton" text dark @click="filterOptions=!filterOptions">
              <strong> {{ $t('MainView.Filter') }} </strong>
              <v-icon dark>
                mdi-filter-outline
              </v-icon>
            </v-btn>
          </v-row>
        </div>
        <v-row justify="center">
          <v-btn class="v-btn-pers" x-large style="border-radius: 10px 10px 0 0; margin-right: 10px" :style="{ color: colorPay}" @click="changeToPay()">
            {{ tabs[0] }}
          </v-btn>
          <v-btn class="v-btn-pers" x-large style="border-radius: 10px 10px 0 0; margin-left: 10px" :style="{ color: colorReceive}" @click="changeToReceive()">
            {{ tabs[1] }}
          </v-btn>
        </v-row>
      </div>
      <div v-show="pay" style="overflow-y: auto; height: 100vh; width: 100%">
        <v-tabs-items v-model="tab">
          <v-tab-item
            :key="tabs[0]"
            class="pa-1"
          >
            <div v-if="invoicesToPayArchived.length !== 0" style="margin-top: 10px; cursor: pointer" @click="payArchived = !payArchived">
              <v-icon v-if="payArchived" style="margin-left: 10px;">
                mdi-archive-outline
              </v-icon>
              <v-icon v-if="!payArchived" style="margin-left: 10px;">
                mdi-archive
              </v-icon>
              <b> {{ $t('MainView.Archived') }} </b>
              <v-divider class="borderDividerArchived" style="margin-top: 10px" />
            </div>
            <div v-for="item in invoicesToPayArchived" v-if="payArchived" :key="item._id" class="white">
              <ItemListInvoice v-if="payer(item.invoice) && filter(item.invoice)" :invoice="item.invoice" :payer="true" :image="item.image.originalName" />
              <v-divider v-if="payer(item.invoice) && filter(item.invoice)" class="borderDividerArchived" />
            </div>

            <div v-for="item in invoicesToPay" :key="item._id" class="white">
              <ItemListInvoice v-if="payer(item.invoice) && filter(item.invoice)" :invoice="item.invoice" :payer="true" :image="item.image.originalName" />
              <v-divider v-if="payer(item.invoice) && filter(item.invoice)" class="borderDivider" />
            </div>

            <div v-if="invoicesToPay && invoicesToPay.length===0 && !payArchived" style="text-align: center; margin-top: 10px">
              <b> {{ $t('Mainview.There are no invoices yet') }}</b>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <div v-show="receive" style="overflow-y: auto; height: 100vh; width: 100%; display: none">
        <v-tabs-items v-model="tab">
          <v-tab-item
            :key="tabs[1]"
            class="pa-1"
          >
            <div v-if="invoicesToReceiveArchived.length !== 0" style="margin-top: 10px; cursor: pointer" @click="receiveArchived = !receiveArchived">
              <v-icon v-if="receiveArchived" style="margin-left: 10px;">
                mdi-archive-outline
              </v-icon>
              <v-icon v-if="!receiveArchived" style="margin-left: 10px;">
                mdi-archive
              </v-icon>
              <b> {{ $t('MainView.Archived') }} </b>
              <v-divider class="borderDividerArchived" style="margin-top: 10px" />
            </div>
            <div v-for="item in invoicesToReceiveArchived" v-if="receiveArchived" :key="item._id" class="white">
              <ItemListInvoice v-if="!payer(item.invoice) && filter(item.invoice)" :invoice="item.invoice" :payer="false" :image="item.image.originalName" />
              <v-divider v-if="!payer(item.invoice) && filter(item.invoice)" class="borderDividerArchived" />
            </div>
            <div v-for="item in invoicesToReceive" :key="item._id" class="white">
              <ItemListInvoice v-if="!payer(item.invoice) && filter(item.invoice)" :invoice="item.invoice" :payer="false" :image="item.image.originalName" />
              <v-divider v-if="!payer(item.invoice) && filter(item.invoice)" class="borderDivider" />
            </div>
            <div v-if="invoicesToReceive && invoicesToReceive.length===0 && !receiveArchived" style="text-align: center; margin-top: 10px;">
              <b> {{ $t('Mainview.There are no invoices yet') }}</b>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <v-btn style="position:absolute;right:25px; bottom: 10px; z-index: 100;border-radius: 10px" class="btn-primary v-floating-button" small dark @click="goUploadInvoice()">
        <v-icon dark large>
          mdi-plus
        </v-icon>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";
import ItemListInvoice from "../components/ItemListInvoice"; 
// import PullTo from 'vue-pull-to';
export default {
    name: "MainView",
    components: {ItemListInvoice},
    data () {
        return {
            name: '62e7a0aeec12bb2bbc5f2a3b.jfif',
            pay: false,
            colorPay: null,
            colorReceive: null,
            receive: false,
            filterOptions: false,
            min: 0,
            max: 1000,
            range: [0, 1000],
            selectedClient: null,
            date: null,
            menu: false,
            menu1: false,
            menu2: false,
            advancedDateMin: null,
            advancedDateMax: null,
            amount: null,
            advancedOpt: false,
            tab: null,
            tabs: [this.$t('To pay'), this.$t('To get paid')],
            invoices: null,
            invoicesToPay: [],
            invoicesToPayArchived: [],
            invoicesToReceive: [],
            invoicesToReceiveArchived: [],
            payArchived: false,
            receiveArchived: false,
            mouseDown: false,
            options: [],
            refreshConfig: {
                pullText: this.$t('Refreshing...'), // The text is displayed when you pull down
                triggerText: this.$t('Refreshing...'), // The text that appears when the trigger distance is pulled down
                loadingText: this.$t('Refreshing...'), // The text in the load
                doneText: this.$t('Refreshing..'), // Load the finished text
                failText: this.$t('MainView.Failed'), // Load failed text
                loadedStayTime: 500, // Time to stay after loading ms
                stayDistance: 50, // Trigger the distance after the refresh
                triggerDistance: 35 // Pull down the trigger to trigger the distance
            },
        };
    },
    computed: {
        showPay () {
            return this.pay;
        },
        showReceiver () {
            return this.receive;
        }
    },
    created () {
        this.fetch();
    },
    methods: {
        changeToPay () {
            this.pay = true;
            this.receive = false;
            this.colorPay = '#00E5FF';
            this.colorReceive = '#000000';
            
        },
        changeToReceive () {
            this.pay = false;
            this.receive = true;
            this.colorPay = '#000000';
            this.colorReceive = '#00E5FF';
        },
        selectTabParams () {
            if (this.$route.params.second === 'true') {
                this.changeToReceive();
                this.tab = 0;
            } else {
                this.tab = 0; //Es fica el mateix ja nomes tenim un sol "tab"
                this.changeToPay();
            }
        },
        activateOptions () {
            this.advancedOpt = !this.advancedOpt;
        },
        advancedOptions (invoice) {
            let filter = true;
            if (this.selectedClient !== null && (this.selectedClient !== invoice.receiverCif && this.selectedClient !== invoice.payerCif)) {
                filter = false;
            }

            if (this.range[0] !== this.min || this.range[1] !== this.max) {
                this.amount = null;
                if (this.range[0] > invoice.amount || this.range[1] < invoice.amount)
                    filter = false;
            } else if (this.amount !== null && this.amount > invoice.amount)
                filter = false;

            if (this.advancedDateMin !== null || this.advancedDateMax !== null) {
                this.date = null;
                if (this.advancedDateMin !== null && this.advancedDateMin > invoice.dueDate)
                    filter = false;
                if (this.advancedDateMax !== null && this.advancedDateMax < invoice.dueDate)
                    filter = false;
            } else if (this.date !== null && this.date > invoice.dueDate)
                filter = false;
            return filter;
        },
        reset () {
            this.selectedClient = null;
            this.amount = null;
            this.date = null;
            this.min = 0;
            this.max = 1000;
            this.range = [0, 1000];
            this.advancedDateMax = null;
            this.advancedDateMin = null;
        },
        resetSelect () {
            this.selectedClient = null;
        },
        filter (invoice) {
            if (this.advancedDateMax !== null || this.advancedDateMin !== null || this.range[0] !== this.min || this.range[1] !== this.max) {
                return this.advancedOptions(invoice);
            }
            let filter = true;
            if (this.selectedClient !== null && (this.selectedClient !== invoice.receiverCif && this.selectedClient !== invoice.payerCif)) {
                filter = false;
            }
            if (this.amount !== null && this.amount > invoice.amount) {
                filter = false;
            }
            if (this.date !== null && this.date > invoice.dueDate) {
                filter = false;
            }
            return filter;
        },
        getOptions () {
            for (let i = 0; i < this.invoices.length; i++) {
                if (this.invoices[i].invoice.payerCif === this.$user.cif) {
                    const payer = this.invoices[i].invoice.receiverCif;
                    if (!this.options.includes(payer)) this.options.push(payer);
                }
                if (this.invoices[i].invoice.receiverCif === this.$user.cif) {
                    const payer = this.invoices[i].invoice.payerCif;
                    if (!this.options.includes(payer)) this.options.push(payer);
                }
            }
        },
        selectTab () {
            if (this.$route.params && this.$route.params.byppay) {
                this.tab = 1;
            } else if (this.$route.params && !this.$route.params.byppay === false ) { this.tab = 0; } else if (this.invoicesToPay.length === 0) { this.tab = 1;  } else if (this.tab === 0 && this.invoicesToPay.length > 0) { this.tab = 0;  } else if (this.tab === 1 && this.invoicesToReceive.length > 0) { this.tab = 1; } else { this.tab = 0; }
        },
        payer (invoice) {
            return  invoice.payer ? this.$user._id === invoice.payer._id : false; //'?' solves undefined problems
        },
        async fetch () {
            this.invoices = [];
            this.invoicesToPay = [];
            this.invoicesToPayArchived = [];
            this.invoicesToReceive = [];
            this.invoicesToReceiveArchived = [];
            this.$root.$emit('start-loading');
            await ApiRepository.getInvoicesInformation(true, true)
                .then((res) => {
                    this.invoices = res.data.invoices;
                    this.invoices.reverse();


                    this.invoices.forEach((invoice) => {
                        ApiRepository.isArchived(invoice.invoice._id, this.$user.cif).then((res) => {
                            if (res.data.isArchived) {
                                if (this.payer(invoice.invoice)) {
                                    this.invoicesToPayArchived.push(invoice);
                                } else {
                                    this.invoicesToReceiveArchived.push(invoice);
                                }
                            } else if (this.payer(invoice.invoice)) {
                                this.invoicesToPay.push(invoice);
                            } else {
                                this.invoicesToReceive.push(invoice);
                            }
                        });
                    });
                    //this.selectTab();
                    this.selectTabParams();
                    this.$root.$emit('stop-loading');
                    this.getOptions();
                    console.log(this.invoicesToReceive);
                })
                .catch((err) => {
                    this.$root.$emit('stop-loading');
                    this.anyInvoiceBeforeFetch = false;
                    let msg = '';
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_LISTING_INVOICES)
                        msg = this.$t('Error listing invoices');
                    else
                        msg =  this.$t('ERROR: Something went wrong');
                    this.$root.$emit('show-snackbar', {message: msg, color: 'error'});

                });
        },
        goUploadInvoice () {
            this.$router.push({name: 'imageInvoice', params: {byppay: this.showPay ? Constants.FORWARD_IDENTIFIER : Constants.BYPPAY_IDENTIFIER }, replace: true});
        },
        refresh (loaded) {
            this.fetch();
            loaded('done');
        },
    },
    sockets: {
        REFRESH_BROWSE () {
            console.log("REFRESH_BROWSE");
            this.fetch();
        },
        REFRESH_payerPaymentToReceiver () {
            console.log("REFRESH_payerPaymentToReceiver");
            this.fetch();
        },
        REFRESH_middlePaymentToReceiverUpdate () {
            console.log("REFRESH_middlePaymentToReceiverUpdate");
            this.fetch();
        },
        REFRESH_middlePaymentToPlatformUpdate () {
            console.log("REFRESH_middlePaymentToPlatformUpdate");
            this.fetch();
        },
        REFRESH_payerPaymentToMiddleUpdate () {
            console.log("REFRESH_payerPaymentToMiddleUpdate");
            this.fetch();
        }
    },

};
</script>

<style scoped>
  .borderDivider {
    /*border-color: var(--v-primary-base) !important;*/
    border-color: #BDBDBD !important;
    border-width : 1px;
  }
  .borderDividerArchived {
    border-color: #BDBDBD !important;
    border-width: 1px;
  }
  .borderDividerArchivator {
    border-color: #4B8EE7 !important;
    border-width: 1px;
  }
  .v-slide-group__content .v-tabs-bar__content{
    background-color: var(--v-background-base) !important;
  }
  .v-tabs{
    letter-spacing: normal !important;
    display: run-in !important;
    flex-direction: row !important;
    justify-content: center !important;
    margin-right: 0;
  }
  .v-btn-pers{
    padding: 30px 50px !important;
    background-color: white !important;
    text-underline-offset: 10px;
    text-decoration: underline;
    margin-top: 5px;
  }
  .v-floating-button{
    min-width: 30px !important;
    min-height: 55px !important;
  }
</style>
